<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/helpcenter/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/helpcenter/add"
    >
      <el-form-item label="分类">
        <el-select v-model="formModel.type">
          <el-option
            v-for="item in helpType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.question"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="myIndex"
        label="序号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="type"
        label="分类"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="question"
        label="问题"
        min-width="320"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="c"
        label="答案"
        min-width="220"
        :formatter="formatterTableData"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.answer.length > 10"
            type="text"
            class="el-icon-view icon"
            @click="answershowDialog(scope.row)"
          ></el-button>
          {{
            scope.row.answer.length > 10
              ? scope.row.answer.slice(0, 10) + "..."
              : scope.row.answer
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/helpcenter/update') || hasPerm('/helpcenter/del')"
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/helpcenter/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button
            type="text"
            v-if="hasPerm('/helpcenter/del')"
            @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="100px"
      dialogWidth="600px"
    >
      <el-form-item label="序号" prop="myIndex">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.myIndex"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="type">
        <el-select v-model="dialogModel.type">
          <el-option
            v-for="item in helpType.slice(1, helpType.length)"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题" prop="question">
        <el-input
          v-model="dialogModel.question"
          maxlength="200"
          show-word-limit
          type="textarea"
          rows="5"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="答案" prop="answer">
        <el-input
          v-model="dialogModel.answer"
          maxlength="5000"
          show-word-limit
          type="textarea"
          rows="10"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </form-dialog>
    <show-info-dialog
      title="答案详细内容"
      :show="true"
      ref="showInfoDialog"
      class="showInfoDialog"
    >
      <h3>问题：</h3>
      <div
        style="white-space: pre-wrap; margin: 10px 10px 10px 35px"
        v-html="answershow.question"
      ></div>
      <h3>答案：</h3>
      <div
        style="white-space: pre-wrap; margin: 10px 10px 10px 35px"
        v-html="answershow.answer"
      ></div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import APPService from "service/APPService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "helpcenter",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      answershow: "",
      helpType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      status: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "开启",
        },
        {
          id: "0",
          value: "关闭",
        },
      ],
      show: false,
      formModel: {
        type: "",
        question: "",
        status: "",
      },
      tableData: [],
      submitService: APPService.helpcenterList,
      itemId: "",
      dialogModel: {
        myIndex: "",
        type: "",
        answer: "",
        question: "",
      },
      dialogRules: {
        myIndex: [
          {
            required: true,
            message: "请输入",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择",
          },
        ],
        answer: [
          {
            required: true,
            message: "请输入",
          },
        ],
        question: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      isFlag: false,
      page: {},
      isPage: false,
      currentTypes: {},
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.getTypeNames("帮助分类", (res) => {
      this.helpType = [...this.helpType, ...res];
    });
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        type: this.formModel.type,
        question: this.formModel.question,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      const params = {
        type: this.dialogModel.type,
        question: this.dialogModel.question,
        answer: this.dialogModel.answer,
        myIndex: this.dialogModel.myIndex,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? APPService.helpcenterEdit
        : APPService.helpcenterInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        type: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        APPService.helpcenterDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        APPService.helpcenterStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        myIndex: "",
        type: "",
        question: "",
        answer: "",
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.records;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    answershowDialog(row) {
      this.answershow = row;
      this.$refs.showInfoDialog.open();
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/HelpCenter.vue